export const PostData = [
  {
    id: "1",
    title: `Express Your Needs in a Snap📷 `,
    background: "#DDDCF5",
    body: "Seamlessly post your specific item by either taking/uploading a photo, searching the web for the perfect image, or simply describing what you're looking for.",
  },
  {
    id: "2",
    title: `Complete Your Post with Ease😌 `,
    background: "#FFE8CC",
    body: " Fill out essential details like specifications, quantity, budget, and delivery location to ensure sellers have all the necessary information to provide the best offers.",
  },
  {
    id: "3",
    title: `Connect with Sellers Instantly⚡`,
    background: "#E8E6FE",
    body: " Engage with a diverse community of sellers who respond to your posts with the products you desire, making your experience on Pamo fast, efficient, and enjoyable.",
  },
];
